import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {XXL_BREAKPOINT_MAX} from "../../../../config/constants"

export const Container = styled("nav", {
    shouldForwardProp: prop => prop !== "xxlBreakpointEnabled",
})<{xxlBreakpointEnabled: boolean}>`
    // TODO: Tech-debt PBI-669702, overwrite mvc css
    border-bottom: none !important;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    max-width: ${({xxlBreakpointEnabled}) => (xxlBreakpointEnabled ? XXL_BREAKPOINT_MAX : breakpoints.values.xl)}px;
    padding: 0 0 2.5rem;
    @media (min-width: ${breakpoints.values.md}px) {
        height: 100%;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        min-height: 30rem;
        max-height: calc(100vh - 7rem);
        overflow-y: hidden;
        padding: 0 1.565rem;
    }
    @media (min-width: ${breakpoints.values.xl}px) {
        padding: 0 1.8125rem;
    }
`
